import React from 'react';
import './Header.css'; // Path to the CSS file

const Header = () => {
  return (
    <header>
      <h1 className="header1">Hi</h1>
      <h2 className="header">I'm EDICHA JULIUS</h2>
      <p className="paragraph">
        A frontend developer passionate about creating user-friendly and interactive web experiences. With several years of experience in HTML, CSS, and JavaScript, I specialize in building responsive and modern web applications.
      </p>
      <p className="paragraph">
        I enjoy collaborating with designers and developers to bring ideas to life. I have a keen eye for detail and strive for pixel-perfect implementation. My goal is to create clean, maintainable code that enhances the user experience.
      </p>
      
    </header>
  );
};

export default Header;
